// src/store/slices/swarmsInActionSlice.js

import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "@reduxjs/toolkit";

const initialState = {
  swarms: [],
  events: [],
  swarmIdSelected: null,
  selectedBuyManagers: [],
  sortOption: 'bteId', // Default sort option
};

const swarmsInActionSlice = createSlice({
  name: "swarmsInAction",
  initialState,
  reducers: {
    addOrUpdateSwarms: (state, action) => {
      if(state.swarms == []){
        state.swarms = action.payload;
        return;
      }
      action.payload.forEach((swarm) => {
        const existingSwarm = state.swarms.findIndex((s) => s.id === swarm.id);
        if (existingSwarm !== -1) {
          state.swarms[existingSwarm] = {...state.swarms[existingSwarm], ...swarm};
        } else {
          state.swarms.push(swarm);
        }
      });
    },
    loadSwarms: (state,action) =>{
      state.swarms = action.payload;
    },
    addOrUpdateSwarm: (state, action) => {
      console.log("action.payload", action.payload);
      const updatedSwarm = action.payload;
      const index = state.swarms.findIndex(swarm => swarm.id === updatedSwarm.id);

      //A: is true that the swarm was edited, but the swarm is stopped and it is not in the list.
      //A: so we must not added to the list, in order to avoid, adding old swarms to the list
      if(updatedSwarm.running == false && index === -1){
        console.log(`swarmId:${updatedSwarm.id} is stopped and is not in the list, no adding it`);
        return;
      }

      if (index !== -1) {
        console.log("addOrUpdateSwarm, swarm: " + updatedSwarm.id + " exists in store and should be included, UPDATE");
        state.swarms[index] = { ...state.swarms[index], ...updatedSwarm };
      } else {
        console.log("addOrUpdateSwarm, swarm: " + updatedSwarm.id + " not exists in store and should be included, ADD");
        state.swarms.push(updatedSwarm);
      }
    },

    setSwarmsInActionCounters:(state, action) => {
      const counterUpdates = action.payload;
      counterUpdates.forEach((counterUpdate) => {
        const index= state.swarms.findIndex(swarm => swarm.id === counterUpdate.swarmId);
        if (index !== -1) {
          state.swarms[index] = { ...state.swarms[index], ...counterUpdate };
        }else{
          console.log("swarm not found: ", counterUpdate.swarmId , " can not update counters");
        }
      });
    },

    removeSwarm: (state, action) => {
      const swarmId = action.payload;
      state.swarms = state.swarms.filter(swarm => swarm.id !== swarmId);
    },

    removeSwarms: (state,action) =>{
      state.swarms=  state.swarms.filter(swarm => !action.payload.includes(swarm.id))
    },

    // Update swarm counter for pending, acceptedm or completed
    updateSwarmCounter: (state, action) => {
      const { id, counterType, value } = action.payload;
      const swarm = state.swarms.find(swarm => swarm.id === id);
      if (swarm) {
        swarm[counterType] = (swarm[counterType] || 0) + value;
      }
    },

    resetSwarms: (state) => {
      state.swarms = [];
    },

    
    setSwarmIdSelected: (state, action) => {
      state.swarmIdSelected = action.payload;
    },

    setSelectedBuyManagers: (state, action) => {
      state.selectedBuyManagers = action.payload;
    },
    setSortOption: (state, action) => {
      state.sortOption = action.payload;
    },
  },
});

export const selectAllSwarms = (state) => state.swarmsInAction.swarms;
export const selectSwarmSelectedId = (state) => state.swarmsInAction.swarmIdSelected;
export const selectSwarmSelected = (state) => state.swarmsInAction.swarms.find(swarm => swarm.id === state.swarmsInAction.swarmIdSelected);
export const selectSelectedBuyManagers = (state) => state.swarmsInAction.selectedBuyManagers;
export const selectSwarmById = (id) => (state) => {
  return state.swarmsInAction.swarms.find(swarm => swarm.id === id) || null;
};

export const selectVisibleSwarms = createSelector(
  [selectAllSwarms],
  (swarms) =>
    swarms.filter(swarm => swarm.running || !swarm.isClosed)
);

//A: This selector is used in ActiveSwarmsTabs.jsx
export const selectFilteredVisibleSwarmsByBuyManagers = createSelector(
  [selectVisibleSwarms, selectSelectedBuyManagers],
  (visibleSwarms, selectedBuyManagers) => {
    if (selectedBuyManagers.includes('showAll')) {
      return visibleSwarms;
    }
    return visibleSwarms.filter(swarm => selectedBuyManagers.includes(swarm.buyManagerId));
  }
);

export const selectSortOption = (state) => state.swarmsInAction.sortOption;

export const {
  addOrUpdateSwarm,
  removeSwarm,
  removeSwarms,
  updateSwarmCounter,
  resetSwarms,
  setSwarmIdSelected,
  setSelectedBuyManagers,
  setSwarmsInActionCounters,
  addOrUpdateSwarms,
  setSortOption,
  loadSwarms,
} = swarmsInActionSlice.actions;

export default swarmsInActionSlice.reducer;
